<template>
    <tbody>
        <CostableTableRow
            class="hover:bg-initial larger-font bolder-font"
            :is-heading-row="true"
            heading-class="text-right"
        >

            <template v-slot:heading>
                <div>
                    Totals:
                </div>
                <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                    Per Guest Totals:
                </div>
            </template>

            <template v-slot:totalCost>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Cost"
                >
                    <div>
                        {{ formatCurrency(totals.cost) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatCurrency(totalsPerGuest.cost) }}
                    </div>
                </span>
            </template>

            <template v-slot:totalPrice>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Price"
                >
                    <div>
                        {{ formatCurrency(totals.price) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatCurrency(totalsPerGuest.price) }}
                    </div>
                </span>
            </template>

            <template v-slot:markup>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Markup"
                >
                    <div>
                        {{ formatCurrency(totals.markup) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatCurrency(totalsPerGuest.markup) }}
                    </div>
                </span>
            </template>

            <template v-slot:margin>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Margin"
                >
                    <div>
                        {{ formatPercentage(totals.margin) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatPercentage(totalsPerGuest.margin) }}
                    </div>
                </span>
            </template>

            <template v-slot:commissionDue>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Commission Due"
                >
                    <div>
                        {{ formatCurrency(totals.commission_due) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatCurrency(totalsPerGuest.commission_due) }}
                    </div>
                </span>
            </template>

            <template v-slot:totalProfit>
                <span
                    v-b-tooltip.hover.top.d50
                    class="d-inline-flex flex-column"
                    title="Total Profit"
                >
                    <div>
                        {{ formatCurrency(totals.profit) }}
                    </div>
                    <div v-if="filteredColumns.some(column => column.name === 'totalsPerGuest') && totalsPerGuest">
                        {{ formatCurrency(totalsPerGuest.profit) }}
                    </div>
                </span>
            </template>
        </CostableTableRow>
    </tbody>
</template>

<script>
import { formatCurrency, formatPercentage } from '@/utils/helpers';
import CostableTableRow from '@/modules/costable/_components/CostableTableRow';

export default {
    components: { CostableTableRow },
    computed: {
        totals() {
            return this.$store.getters['costable/totals'];
        },
        totalsPerGuest() {
            return this.$store.getters['costable/totalsPerGuest'];
        },
        columns() {
            return [
                ...this.$store.getters['costable/totalRows'],
            ];
        },
        filteredColumns() {
            return this.columns
                .filter(column => (!this.$store.getters['costable/hiddenColumns'].includes(column.name)));
        },
    },

    methods: {
        formatCurrency,
        formatPercentage,
    },

};
</script>

<style lang="scss" scoped>
.larger-font {
    font-size: 14px;
}
.bolder-font {
    font-weight: 600;
}
</style>
